// extracted by mini-css-extract-plugin
module.exports = {"ProductCard":"ProductCard_ProductCard__3EAk1","quantity":"ProductCard_quantity__2ELK4","decrement":"ProductCard_decrement__-sxme","increment":"ProductCard_increment__1vjlJ"};